export const APP_LINK_APP_STORE = 'https://apps.apple.com/app/gold-avenue/id6478158109';

export const APP_LINK_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.goldavenue.goldavenue';
